import { Option } from '@@/form-components/PortainerSelect';

/**
 * matchingRepositories offers the registry's repositories that contain what has
 * been typed, for the chart and image fields alike.
 *
 * Nothing is offered for an empty field: a registry can hold hundreds of
 * repositories, and both fields read empty as "use the default" rather than as an
 * invitation to browse.
 */
export function matchingRepositories(
  value: string,
  repositories?: Array<string>
): Array<Option<string>> {
  if (!value || !repositories) {
    return [];
  }

  return repositories
    .filter((repository) =>
      repository.toLowerCase().includes(value.toLowerCase())
    )
    .map((repository) => ({ label: repository, value: repository }));
}
